import type { FlagConfiguration } from '@atlassian/jira-flags'; // ignore-for-ENGHEALTH-17759
import type { ShowSprintStartedFlagAction } from '../../state/actions/sprints/start/index.tsx';
import flagMessages from './messages.tsx';

export const showSprintStartedFlag = (): FlagConfiguration => ({
	type: 'success',
	title: flagMessages.sprintStartedTitle,
	description: flagMessages.sprintStartedParallelSprintDescription,
	messageId: 'software-backlog.flags.sprint-started-flag.flag.success.flags.sprint-started',
	messageType: 'transactional',
});

export type Action = ShowSprintStartedFlagAction;
